<template>
  <div :class="'data-center-content' + (isSaas ? ' saas' : '')">
    <div class="data-center-head">
      <div class="data-head-btn data-head-btn-left">
        <img v-if="hasDataCenterPermis('dataCenter/dataHome') && !isSaas" src="@/assets/images/dataCenter/data-index-bg.png" alt="首页按钮" @click="changePage(1)">
      </div>
      <div class="data-head-tab">
        <div class="data-head-tab-left">
          <div v-if="hasDataCenterPermis('dataCenter/dataHome') && isSaas" class="data-head-tab-item" @click="changePage(1)">
            <div :class="{'tab-item-active':pageActive == 2}">首页</div>
            <div v-if="pageActive == 2" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/dataWarehouseInOut')" class="data-head-tab-item" @click="changePage(2)">
            <div :class="{'tab-item-active':pageActive == 2}">仓库出入库统计</div>
            <div v-if="pageActive == 2" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/dataWarehouseIncome')" class="data-head-tab-item" @click="changePage(3)">
            <div :class="{'tab-item-active':pageActive == 3}">仓库收入统计</div>
            <div v-if="pageActive == 3" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/merchantCensus')" class="data-head-tab-item" @click="changePage(6)">
            <div :class="{'tab-item-active':pageActive == 6}">商户统计</div>
            <div v-if="pageActive == 6" class="tab-item-bar"></div>
          </div>
        </div>
        <div style="width: 300px;"></div>
        <div class="data-head-tab-center">
          <span>数据中心平台</span>
        </div>
        <div class="data-head-tab-right">
          <div v-if="hasDataCenterPermis('dataCenter/dataSupplier')" class="data-head-tab-item" @click="changePage(4)">
            <div :class="{'tab-item-active':pageActive == 4}">供应商数据统计</div>
            <div v-if="pageActive == 4" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/dataCommoditySales')" class="data-head-tab-item" @click="changePage(5)">
            <div :class="{'tab-item-active':pageActive == 5}">商品销售统计</div>
            <div v-if="pageActive == 5" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/supplierCensus')" class="data-head-tab-item" @click="changePage(7)">
            <div :class="{'tab-item-active':pageActive == 7}">供应商统计</div>
            <div v-if="pageActive == 7" class="tab-item-bar"></div>
          </div>
          <div v-if="hasDataCenterPermis('dataCenter/commodityAnalysis')" class="data-head-tab-item" @click="changePage(8)">
            <div :class="{'tab-item-active':pageActive == 8}">商品分析</div>
            <div v-if="pageActive == 8" class="tab-item-bar"></div>
          </div>
        </div>
        <img class="data-head-bright" src="@/assets/images/dataCenter/data-head-bright.png">
      </div>
      <div class="data-head-btn data-head-btn-right">
        <div class="header-right">
          <img src="@/assets/images/dataCenter/data-admin-bg.png" @click="$router.push('/')" alt="后台按钮">
        <!-- 全屏显示 -->
          <div @click="handleFullScreen" class="FullScreen-btn">
            <el-tooltip effect="dark"
              :content="fullscreen?`取消全屏`:`全屏`"
              placement="bottom"
            >
              <i class="el-icon-rank"></i>
            </el-tooltip>
          </div>
        </div>
      <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name"
          trigger="click"
          @command="handleCommand"
        >
          <span class="el-dropdown-link">
            {{username}}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">修改密码</el-dropdown-item>
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="修改密码"
          :visible.sync="dialogVisible"
          width="45%"
          :before-close="handleClose"
        >
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item
              prop="acount"
              label="账号:"
            >
              <el-input :disabled="true" v-model="ruleForm.acount"></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              label="输入新密码:"
            >
              <el-input placeholder="请输入新密码" v-model="ruleForm.password" show-password></el-input>
            </el-form-item>
            <el-form-item
              prop="passwordcm"
              label="确认新密码:"
            >
              <el-input
                placeholder="请输入确认新密码"
                v-model="ruleForm.passwordcm"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <img class="data-head-line" src="@/assets/images/dataCenter/data-head-line.png" alt="">
    </div>
    <div class="data-center-body">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import user from './../../store/user/index'
import dataCenter from './../../store/dataCenter/index'
import { EDITPASSWARD } from './../../store/toggle/types'
import { SETDATACENTERPERMIS, LOGOUT } from '@/store/user/types.js'
export default {
  name: 'dataCenter',
  data () {
    return {
      fullscreen: false,
      dialogVisible: false,
      ruleForm: {
        acount: localStorage.getItem('accout'),
        password: '',
        passwordcm: ''
      },
      // 表单校验
      rules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        passwordcm: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { required: false, trigger: 'blur', validator: this.userPassWord }
        ]
      }
    }
  },
  computed: {
    dataCenterPermis () {
      return user.state.dataCenterPermis
    },
    username () {
      return user.state.userinfo.user ? user.state.userinfo.user.name : this.name
    },
    pageActive () {
      return dataCenter.state.pageAct
    },
    // 是否为超级管理员
    isSaas () {
      return user.state.userinfo.identity === 3
    },
    userinfo () {
      return user.state.userinfo
    }
  },
  created () {
    window.onresize = () => {
      if (!this.checkFull()) {
        this.fullscreen = false
      }
    }
  },
  mounted () {
  },
  methods: {
    // 切换页面
    changePage (page) {
      switch (page) {
        case 1:
          this.$router.push('/dataCenter/dataHome')
          break
        case 2:
          if (this.dataCenterPermis[0] === 'dataCenter/dataWarehouseInOut') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/dataWarehouseInOut')
          break
        case 3:
          if (this.dataCenterPermis[0] === 'dataCenter/dataWarehouseIncome') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/dataWarehouseIncome')
          break
        case 4:
          if (this.dataCenterPermis[0] === 'dataCenter/dataSupplier') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/dataSupplier')
          break
        case 5:
          if (this.dataCenterPermis[0] === 'dataCenter/dataCommoditySales') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/dataCommoditySales')
          break
        case 6: // 商户统计
          if (this.dataCenterPermis[0] === 'dataCenter/merchantCensus') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/merchantCensus')
          break
        case 7: // 供应商统计
          if (this.dataCenterPermis[0] === 'dataCenter/supplierCensus') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/supplierCensus')
          break
        case 8: // 商品分析
          if (this.dataCenterPermis[0] === 'dataCenter/commodityAnalysis') this.$router.push('/dataCenter')
          else this.$router.push('/dataCenter/commodityAnalysis')
          break
        default:
          this.$router.push('/dataCenter')
      }
    },
    hasDataCenterPermis (path) {
      return this.dataCenterPermis && this.dataCenterPermis.length && this.dataCenterPermis.some((x) => x === path)
    },
    // 全屏事件
    handleFullScreen () {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    // 用户名下拉菜单选择事件
    handleCommand (command) {
      if (command === 'loginout') {
        // localStorage.removeItem('ms_username');
        this.$store.dispatch(LOGOUT)
        this.$store.dispatch(SETDATACENTERPERMIS)
      } else if (command === 'edit') {
        this.dialogVisible = true
        this.ruleForm = {
          acount: localStorage.getItem('accout'),
          password: '',
          passwordcm: ''
        }
      }
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm
          let params = {
            password: data.password
          }
          this.$store.dispatch(EDITPASSWARD, params)
        } else {
          return false
        }
      })
    },
    checkFull () {
      // 判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      // 火狐浏览器
      var isFull = document.mozFullScreen ||
          document.fullScreen ||
          // 谷歌浏览器及Webkit内核浏览器
          document.webkitIsFullScreen ||
          document.webkitRequestFullScreen ||
          document.mozRequestFullScreen ||
          document.msFullscreenEnabled
      if (isFull === undefined) {
        isFull = false
      }
      return isFull
    }

  }
}
</script>
<style scoped>
.data-center-content{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #fff;
    background: url('./../../assets/images/dataCenter/dataCenter-bg.jpg') no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    min-width: 900px;
    zoom: 1;
    overflow: hidden;
}
.data-center-content.saas {
    background: url('./../../assets/images/dataCenter/data-center-bg.jpg') no-repeat;
    background-size: 1920px 100%;
}
.data-center-head{
    width: 100%;
    height: 7%;
    max-height: 74px;
    min-height: 54px;
    background: url('./../../assets/images/dataCenter/dataCenter-head-bg.png') no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    min-width: 900px;
    zoom: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 10px;
    position: relative;
}
.data-head-line{
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  left: 0;
}
.data-head-btn{
  width: 200px;
}
.data-head-btn-left > img{
  width: 120px;
  height: auto;
  cursor: pointer;
  position: absolute;
  z-index: 10;
  top: calc(50% - 27.5px);
}
.data-head-btn-right .header-right > img {
  width: 90px;
  height: auto;
  cursor: pointer;
}
.data-head-btn-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.data-head-btn-right .header-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.data-head-btn-right .header-right .el-icon-rank{
  color: #fff !important;
  font-size: 18px;
  vertical-align: middle;
}
.data-head-btn-right .header-right .FullScreen-btn{
  transform: rotate(45deg);
  cursor: pointer;
}
.user-name .el-dropdown-link{
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
.data-head-tab{
  color: #fff;
  font-weight: 600;
  font-size: 0.906rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 440px);
  max-width: 1000px;
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.data-center-content.saas .data-head-tab {
  width: 80%;
  max-width: 1400px;
}
.data-center-content.saas .data-head-tab-item {
  font-size: 18px;
}
.data-head-tab-center{
  position: absolute;
  top: 0;
  left: calc(50% - 150px);
  width: 300px;
  height: calc(100% - 11px);
  background: url('./../../assets/images/dataCenter/data-title-bg.png') no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  /* font:700 20px simsun; */
  font-weight: 600;
  font-size: 1.18rem;
  letter-spacing:5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.data-head-bright{
  position: absolute;
  width: 700px;
  height: 200%;
  left: calc(50% - 350px);
  bottom: -100%;
  /* z-index: 99; */
}
.data-head-tab-item{
  width: 50%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.data-head-tab-left, .data-head-tab-right{
  width: calc(50% - 150px);
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 100;
}
.data-head-tab-left {
  justify-content: flex-end;
}
.data-head-tab-right{
  justify-content: flex-start;
  right: 0;
}
.tab-item-bar{
  background-image: linear-gradient(to left, #177ACD, #34DCFC);
  width: 90px;
  height: 4px;
  border-radius: 10px;
  position: absolute;
  bottom: -1px;
}
.tab-item-active{
  color: #1EDFF8;
}
.data-center-body{
  height: 93%;
  max-height: calc(100% - 54px);
  min-height: calc(100% - 74px);
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/dataCenter/index.vue